import React from 'react'
import { CustomFormProps } from 'types/common'
import LogisticSelectInput from 'ui-shared/CustomInputs/LogisticSelectInput'
import UpsellingFacetSection from 'ui-shared/Facets/FacetFormSections/UpsellingFacetSection'
import UpsellingForm from 'ui-shared/Forms/UpsellingForm'
import { foodUpsellingVS } from 'services/validations/catalog/foodUpselling'
import { yupResolver } from '@hookform/resolvers/yup'

const FoodUpsellingForm: React.FC<CustomFormProps> = (props) => {
  return (
    <UpsellingForm
      {...props}
      relatedProduct="foods"
      resolver={yupResolver(foodUpsellingVS)}
      facetFields={<UpsellingFacetSection />}
    >
      <LogisticSelectInput />
    </UpsellingForm>
  )
}

export default FoodUpsellingForm
